<template>
  <a
    :href="to"
    :class="colorClass"
    target="_blank"
    class="cursor-pointer"
    :aria-label="`Перейти в ${socialNames[name]}`"
    @click="analytics(name)"
  >
    <IconVk
      v-if="name === 'vk'"
    />
    <IconOk
      v-if="name === 'ok'"
    />
    <IconTiktok
      v-if="name === 'tiktok'"
    />
    <IconYoutube
      v-if="name === 'youtube'"
    />
  </a>
</template>

<script>
import IconOk from '~/assets/svg/footer/ok.svg?component'
import IconTiktok from '~/assets/svg/footer/tiktok.svg?component'
import IconVk from '~/assets/svg/footer/vk.svg?component'
import IconYoutube from '~/assets/svg/footer/youtube.svg?component'
const SOCIAL_MAP = {
  vk: 'https://vk.com/polka_russia',
  ok: 'https://ok.ru/group/68835994435629',
  tiktok: 'https://www.tiktok.com/@polka_rent_rus',
  youtube: 'https://www.youtube.com/@Polka_Rent',
}
const SOCIAL_NAMES = {
  vk: 'ВКонтакте',
  ok: 'Одноклассники',
  tiktok: 'TikTok',
  youtube: 'YouTube',
}
export default {
  components: {
    IconVk,
    IconOk,
    IconTiktok,
    IconYoutube,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    socialMap: SOCIAL_MAP,
    socialNames: SOCIAL_NAMES,
  }),
  computed: {
    to () {
      return this.socialMap[this.name]
    },
    colorClass () {
      return `rm-icon${this.color}`
    },
  },
  methods: {
    analytics (name) {
      this.$tracking.logEventAmplitude('click contact', {
        'contact code': name.toUpperCase(),
      })
    },
  },
}
</script>

<style lang="sass" scoped>
  @use "sass:color"
  $color: #B1B5C4
  $colorYellow: #FABF35
  .rm-icon
    width: 24px
    height: 24px
    :deep(svg)
      path
        fill: $color
    &:hover
      :deep(svg)
        path
          fill: color.adjust($color, $lightness: -20%)

  .rm-iconyellow
    :deep(svg)
      path
        fill: $colorYellow
    &:hover
      :deep(svg)
        path
          fill: color.adjust($colorYellow, $lightness: -20%)

  .rm-iconwhite
    :deep(svg)
      path
        fill: #fff
    &:hover
      :deep(svg)
        path
          fill: color.adjust(#fff, $lightness: -20%)
</style>
